<template>
  <div>
    <b-row v-if="activity.controller != null && (activity.isDone || activity.isWontDo)">
      <b-col md="2">{{ $t("controlled") }}:
      {{activity.field9}}
      </b-col>
      <b-col md="4">
        <b-form-radio-group buttons v-model.lazy="activity.controlled_status">
          <b-form-radio
            v-if="
              (!disableFields && ($userIsCompanyAdmin() || $user.id == activity.controller.user.id)) ||
              activity.isControlledApproved
            "
            :value="controlledStatusApproved"
            button-variant="outline-dark"
          >
            {{ $t("approved") }}
          </b-form-radio>
          <b-form-radio
            v-if="
              (!disableFields && ($userIsCompanyAdmin() || $user.id == activity.controller.user.id)) ||
              activity.isControlledNotApproved
            "
            :value="controlledStatusNotApproved"
            button-variant="outline-dark"
          >
            {{ $t("notApproved") }}
          </b-form-radio>
        </b-form-radio-group>
        <br />
        <span>
          {{ activity.controlled_by ? activity.controlled_by.fullName : "" }}
          <br />
          {{ activity.controlled_date }}
        </span>
      </b-col>
      <b-col md="6"
        v-if="
        (!disableFields && activity.controller != null &&
          ($userIsCompanyAdmin() || $user.id == activity.controller.user.id) &&
          (activity.isDone || activity.isWontDo)) ||
        (activity.controlled_comment != '' && activity.controlled_comment != null)
      ">
        <span @click="clickCounter++">{{ $t("comment") }}:</span>
        <text-editor
          :disabled="disableFields || !($userIsCompanyAdmin() || $user.id == activity.controller.user.id)"
          v-model="activity.controlled_comment"
          :minHeight="5"
          p_showMenu="dynamic"
          :p_click="clickCounter"
        ></text-editor>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Activity from "@/models/Activity";
import { ACTIVITY_CONTROLLED_STATUS_TYPES } from "@/constants";
import TextEditor from "@/components/TextEditor/TextEditor";

export default {
  name: "ActivityControlled",
  components: {TextEditor},
  props: {
    editedActivity: {
      type: Activity,
      required: false,
      default: null
    },
    p_disableFields: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      activity: this.editedActivity,
      persons: [],
      link_options: [],
      editFields: false,
      loading: false,
      disableFields: true,
      clickCounter: 0
    };
  },
  mounted() {},
  watch: {
    editedActivity(activity) {
      this.activity = activity;
    },
    p_disableFields(disabled) {
      this.disableFields = disabled;
    }
  },
  computed: {
    controlledStatusApproved() {
      return ACTIVITY_CONTROLLED_STATUS_TYPES.APPROVED;
    },
    controlledStatusNotApproved() {
      return ACTIVITY_CONTROLLED_STATUS_TYPES.NOT_APPROVED;
    }
  },
  methods: {
  }
};
</script>

<style scoped lang="scss"></style>
